import Draggable from './Draggable';

export default Draggable;



// WEBPACK FOOTER //
// ./src/components/DraggableEntity/index.jsx